<template>
  <div>
    <p class="text-subtitle-1">
      <strong class="pr-2 font-weight-normal">
        {{ $t('COMPANIES.ITEM') }}:
      </strong>
      <span class="font-weight-normal text--secondary">
        {{ company.name }}
      </span>
    </p>

    <v-row v-if="selectPerson" align="center">
      <v-col cols="12" md="9">
        <select-person
          v-model="form.person_id"
          :error-messages="errors.person_id"
          :rules="getRulesByName('person_id')"
          @change="changePerson"
        />
      </v-col>

      <v-col cols="12" md="3">
        <v-btn @click="toggleSelectPerson">
          <v-icon class="mr-1" small>mdi-plus</v-icon>
          {{ $t('BUTTON.ADD') }}
        </v-btn>
      </v-col>
    </v-row>

    <person-form
      v-else
      v-model="form.person"
      :show-fields="[
        'salutation',
        'firstName',
        'lastName',
        'gender',
        'language_id'
      ]"
      :errors="errors.person"
      :readonly="!isCreated"
      @input="emitter"
      @update-prop="updatePropWrapPrefix(...arguments, 'person')"
    />

    <work-profile-form
      v-model="form"
      :errors="errors"
      @input="emitter"
      @update-prop="updateProp(...arguments)"
    />

    <v-divider class="py-3" />

    <v-row align="center">
      <v-col cols="12" md="4">
        <v-checkbox
          v-model="form.is_bewirtschafter"
          name="is_bewirtschafter"
          class="pr-4"
          :label="$t('CONTACT_PERSONS.ACCESS_TO_IMMOPORTAL')"
          :error="errors.is_bewirtschafter"
          @change="updateValue('is_bewirtschafter', $event)"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="8">
        <v-sheet class="pa-3" outlined rounded>
          <user-immoportal-form
            v-model="form.user"
            :errors="errors.user"
            :readonly="!form.is_bewirtschafter"
            @input="emitter"
            @update-prop="updatePropWrapPrefix(...arguments, 'user')"
          />
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { get } from 'lodash';
import { mapActions } from 'vuex';
import formEditable from '@/modules/_global/mixins/form-editable';
import { requiredSelectNotArray } from '@/modules/_global/variables/rules';

export default {
  name: 'ContactPersonForm',

  components: {
    SelectPerson: () => import('../SelectPerson'),
    PersonForm: () => import('./PersonForm'),
    WorkProfileForm: () => import('./WorkProfileForm'),
    UserImmoportalForm: () => import('./UserImmoportalForm')
  },

  mixins: [formEditable],

  props: {
    selectPerson: {
      type: Boolean,
      default: true
    },
    company: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    form: {
      user: {},
      person: {},
      user_id: null,
      person_id: null,
      is_bewirtschafter: false
    },
    rules: {
      person_id: requiredSelectNotArray
    }
  }),

  computed: {
    isCreated() {
      return !this.form.id;
    }
  },

  watch: {
    selectPerson(val) {
      if (!val) {
        this.clearPersonUserData();
      }
    }
  },

  methods: {
    ...mapActions('person', ['retrievePerson']),

    changePerson(personId) {
      if (personId) {
        this.retrievePerson(personId).then(({ data }) => {
          this.form.user_id = get(data, 'user.id', null);
          this.form.user.email = get(data, 'user.email', null);
        });
      } else {
        this.clearPersonUserData();
      }

      this.updateValue('person_id', personId);
    },

    clearPersonUserData() {
      this.form.user_id = null;
      this.form.user.email = null;
      this.updatePropWrapPrefix('email', null, 'user');
    },

    toggleSelectPerson() {
      this.$emit('update:selectPerson', !this.selectPerson);
    }
  }
};
</script>
